/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Grid, TextInput } from '../../../canvasComponents/index';
import { ReactComponent } from '@formio/react';
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl';
import CustomAddDepartmentSettings from './CustomAddDepartment.settingsForm';
import getLocalParams from '../localizationCustoms';
import './CustomAddDepartment.scss';

const CustomAddDepartment = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      openEnterManuallySection: false,
      addAnotherReportFields: false,
      fields: ['department', 'reportNumber'],
    };
    this.handleEnterManually = this.handleEnterManually.bind(this);
    this.setValue = this.setValue.bind(this);
    this.getValueKeys = this.getValueKeys.bind(this);
  }

  componentDidMount() {
    const { state: { value, fields }, props: { onChange } } = this;

    if (value) {
      const showManuallyFields = Object.values(value[this.getValueKeys()[0]]).some((v) => v && v.value !== ''); // true if value[key] has some '' value
      const showAnotherReportFields = Object.values(value[this.getValueKeys()[1]]).some((v) => v && v.value !== ''); // true if value[key] has some '' value
      if (showManuallyFields || showAnotherReportFields) {
        const tempAddDepartmentObj = { ...value };
        if (!showManuallyFields && showAnotherReportFields) {
          fields.forEach((field) => {
            tempAddDepartmentObj[this.getValueKeys()[0]][field] = { ...tempAddDepartmentObj[this.getValueKeys()[1]][field] };
          });
          this.clearValues(tempAddDepartmentObj, this.getValueKeys()[1], fields);
          this.setState(() => ({ value: tempAddDepartmentObj }), () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          });
        }
        this.setState({ value: tempAddDepartmentObj, openEnterManuallySection: showManuallyFields || showAnotherReportFields, addAnotherReportFields: showManuallyFields && showAnotherReportFields }, () => {
          // eslint-disable-next-line react/destructuring-assignment
          onChange(this.state.value);
        });
      }
    } else {
      this.setState({ openEnterManuallySection: false, addAnotherReportFields: false }, () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      });
    }
  }

  handleEnterManually() {
    const { state: { value }, props: { onChange, component } } = this;
    const additionalType = component.key.toLowerCase(); // "police" or "fire"
    let newAddDepartmentObj = {};
    if (value) {
      newAddDepartmentObj = value;
    } else {
      newAddDepartmentObj = {
        [`additional${additionalType.charAt(0).toUpperCase() + additionalType.slice(1)}`]: true,
        [`isAdditional${additionalType.charAt(0).toUpperCase() + additionalType.slice(1)}`]: true,
        [`${additionalType}1`]: {
          department: {
            value: '',
            review: {
              label: 'Department',
            },
          },
          reportNumber: {
            value: '',
            review: {
              label: 'Report Number',
            },
          },
        },
        [`${additionalType}2`]: {
          department: {
            value: '',
            review: {
              label: 'Department',
            },
          },
          reportNumber: {
            value: '',
            review: {
              label: 'Report Number',
            },
          },
        },
      };
    }

    this.setState({ value: newAddDepartmentObj, openEnterManuallySection: true }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  }

  getValueKeys() {
    const { state: { value }, props: { component } } = this;
    const additionalType = component.key.toLowerCase(); // "police" or "fire"
    const additionalField = `additional${additionalType.charAt(0).toUpperCase() + additionalType.slice(1)}`; // "additionalPolice" or "additionalFire"
    const isAdditionalField = `isAdditional${additionalType.charAt(0).toUpperCase() + additionalType.slice(1)}`; // "isAdditionalPolice" or "isAdditionalFire"
    const valueKeys = value ? Object.keys(value).filter((v) => v !== additionalField && v !== isAdditionalField).sort() : undefined; // ["additionalPolice", "isAdditionalPolice", "police1", "police2"] -> ["police2", "police1"] -> ["police1", "police2"]
    return valueKeys;
  }

  setValue(v, key, field) {
    const { state: { value }, props: { onChange } } = this;
    const tempAddDepartmentObj = { ...value };
    tempAddDepartmentObj[key][field].value = v;
    this.setState(() => ({ value: tempAddDepartmentObj }), () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  }

  removeEntry(key, fields, index) {
    const { state: { value }, props: { onChange } } = this;
    if (index === 0) {
      const tempAddDepartmentObj = { ...value };
      fields.forEach((field) => {
        tempAddDepartmentObj[this.getValueKeys()[0]][field] = { ...tempAddDepartmentObj[this.getValueKeys()[1]][field] };
      });
      this.clearValues(value, this.getValueKeys()[1], fields);
    } else {
      this.clearValues(value, key, fields);
    }
    this.setState((prevState) => ({ openEnterManuallySection: prevState.addAnotherReportFields, addAnotherReportFields: false }), () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  }

  clearValues(value, key, fields) {
    const { props: { onChange } } = this;
    const tempAddDepartmentObj = { ...value };
    fields.forEach((field) => {
      tempAddDepartmentObj[key][field].value = '';
    });
    this.setState(() => ({ value: tempAddDepartmentObj }), () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  }

  render() {
    const { state: { value, openEnterManuallySection, addAnotherReportFields, fields }, props: { onChange, disabled, intl } } = this;

    return (
      <>
        {!openEnterManuallySection && (
          <button
            type="button"
            tabIndex="0"
            className="enterManuallyButton"
            style={{ marginTop: '5px' }}
            onClick={this.handleEnterManually}
          ><FormattedMessage id="Enter manually" defaultMessage="Enter manually" />
          </button>
        )}
        {value && openEnterManuallySection && (
          <div className="addDepartmentContainer">
            <Grid key={0}>
              <>
                <div style={{ display: 'flex', textAlign: 'center', marginBottom: '8px', marginTop: '16px' }}>
                  <p className="enterManuallyTitle"><FormattedMessage id="Enter info manually" defaultMessage="Enter info manually" /></p>
                  <button
                    type="button"
                    tabIndex="0"
                    className="removeEnterManuallyButton"
                    onClick={() => this.removeEntry(this.getValueKeys()[0], fields, 0)}
                  >
                    <FormattedMessage id="Remove" defaultMessage="Remove" />
                  </button>
                </div>
                <Grid.Row mr0>
                  <Grid.Column colMd6 colSm12>
                    <TextInput
                      className="question-margin-xsmall"
                      primary
                      disabled={disabled}
                      placeholder={intl.formatMessage({ id: 'Department', defaultValue: 'Department' })}
                      defaultValue={Object.values(value[this.getValueKeys()[0]])[0].value}
                      onChange={(v) => this.setValue(v, this.getValueKeys()[0], 'department')}
                      maxLength={60}
                    />
                  </Grid.Column>
                  <Grid.Column colMd6 colSm12>
                    <TextInput
                      className="question-margin-xsmall"
                      primary
                      disabled={disabled}
                      placeholder={intl.formatMessage({ id: 'Report number', defaultValue: 'Report number' })}
                      defaultValue={Object.values(value[this.getValueKeys()[0]])[1].value}
                      onChange={(v) => this.setValue(v, this.getValueKeys()[0], 'reportNumber')}
                      maxLength={60}
                    />
                  </Grid.Column>
                </Grid.Row>
                {value[this.getValueKeys()[1]].department.value.length === 0
                && value[this.getValueKeys()[1]].reportNumber.value.length === 0
                && addAnotherReportFields === false && (
                <button
                  type="button"
                  className="addNewElementButton"
                  onClick={() => {
                    this.setState(() => ({ addAnotherReportFields: true }), () => {
                      // eslint-disable-next-line react/destructuring-assignment
                      onChange(this.state.value);
                    });
                  }}
                ><FormattedMessage id="Add another report" defaultMessage="Add another report" />
                </button>
                )}
              </>
              {addAnotherReportFields && (
              <div className="">
                <div style={{ display: 'flex', textAlign: 'center', marginTop: '18px', marginBottom: '8px' }}>
                  <p className="enterManuallyTitle"><FormattedMessage id="Additional report" defaultMessage="Additional report" /></p>
                  <button
                    type="button"
                    tabIndex="0"
                    className="removeEnterManuallyButton"
                    onClick={() => this.removeEntry(this.getValueKeys()[1], fields, 1)}
                  >
                    <FormattedMessage id="Remove" defaultMessage="Remove" />
                  </button>
                </div>
                <Grid.Row mr0>
                  <Grid.Column colMd6 colSm12>
                    <TextInput
                      className="question-margin-xsmall"
                      primary
                      disabled={disabled}
                      placeholder={intl.formatMessage({ id: 'Department', defaultValue: 'Department' })}
                      defaultValue={Object.values(value[this.getValueKeys()[1]])[0].value}
                      onChange={(v) => this.setValue(v, this.getValueKeys()[1], 'department')}
                      maxLength={60}
                    />
                  </Grid.Column>
                  <Grid.Column colMd6 colSm12>
                    <TextInput
                      className="question-margin-xsmall"
                      primary
                      disabled={disabled}
                      placeholder={intl.formatMessage({ id: 'Report number', defaultValue: 'Report number' })}
                      defaultValue={Object.values(value[this.getValueKeys()[1]])[1].value}
                      onChange={(v) => this.setValue(v, this.getValueKeys()[1], 'reportNumber')}
                      maxLength={60}
                    />
                  </Grid.Column>
                </Grid.Row>
              </div>
              )}
            </Grid>
          </div>
        )}
      </>
    );
  }
};

const CustomAddDepartmentWithIntl = injectIntl(CustomAddDepartment);

export default class AddDepartmentComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'CustomAddDepartment',
      icon: 'tasks',
      group: 'data',
      documentation: '',
      schema: AddDepartmentComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customAddDepartment',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomAddDepartmentSettings;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomAddDepartmentWithIntl
          forwardRef={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue}
        />
      </IntlProvider>,
      element,
      // eslint-disable-next-line no-return-assign
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
